/* eslint-disable @typescript-eslint/naming-convention */
export enum ESurveysActionType {
	GET_SURVEYS_LIST = 'getSurveysList',
	CREATE_SURVEY = 'createSurvey',
	GET_SURVEY = 'getSurvey',
	EDIT_SURVEY = 'editSurvey',
}
